import {Subscription} from 'rxjs';
import {OnDestroy} from '@angular/core';
import {ProfileStatusAvatarModel} from '../profile-status-avatar/profile-status-avatar.component';

export interface FullNameModel {
  first_name: string;
  middle_name: string;
  last_name: string;
}

export abstract class BaseUsersCardComponent implements OnDestroy {
  subscriptions: Subscription[] = [];
  profileStatusAvatarModel: ProfileStatusAvatarModel | null = null;

  protected constructor() {
  }

  getFullName(model: FullNameModel) {
    let fullName = '';
    if (model) {
      if (model.last_name) {
        fullName += model.last_name + ' ';
      }
      if (model.first_name) {
        fullName += model.first_name + ' ';
      }
      if (model.middle_name) {
        fullName += model.middle_name;
      }
    }
    return fullName;
  }

  abstract isExtendedRegistrationStatus(status: string): boolean;

  ngOnDestroy(): void {
    this.subscriptions.forEach(i => i ? i.unsubscribe() : '');
  }
}
